import { observer } from "mobx-react-lite";
import { Button } from "@/components/ui/button";
import { Info, X } from "lucide-react";
import { useTran } from "@/hooks";
import { useESGDataEntryStore } from "@/features/esg/hooks/useESGReportStore";

const DataEntryPrefillBanner = observer(() => {
  const { t } = useTran();
  const {
    showPrefillBanner,
    prefillSuggestions,
    dismissPrefillBanner,
    setShowPrefillModal,
    applyPrefillSuggestions,
  } = useESGDataEntryStore();

  if (!showPrefillBanner) return null;

  const count = prefillSuggestions.length;
  const sources = [
    ...new Set(prefillSuggestions.map((m) => m.sourceReportName)),
  ];
  const sourceText =
    sources.length === 1 ? `"${sources[0]}"` : `${sources.length} reports`;

  return (
    <div className="bg-blue-50 dark:bg-blue-950/20 border border-blue-200 dark:border-blue-800 rounded-radius p-4 mb-4">
      <div className="flex items-start gap-3">
        <Info className="h-5 w-5 text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm font-medium text-blue-900 dark:text-blue-100">
            {t(
              "We found matching data from {{source}} that can auto-fill {{count}} disclosure(s)",
              {
                source: sourceText,
                count,
              },
            )}
          </p>
          <div className="flex items-center gap-2 mt-3">
            <Button
              size="sm"
              variant="outline"
              onClick={() => setShowPrefillModal(true)}
            >
              {t("View Details")}
            </Button>
            <Button size="sm" onClick={applyPrefillSuggestions}>
              {t("Apply Values")}
            </Button>
            <Button size="sm" variant="ghost" onClick={dismissPrefillBanner}>
              {t("Dismiss")}
            </Button>
          </div>
        </div>
        <Button
          size="sm"
          variant="ghost"
          onClick={dismissPrefillBanner}
          className="flex-shrink-0"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
});

export default DataEntryPrefillBanner;
